module.exports = __webpack_public_path__ + "media/images/fire-gap-icon-fc28837f05e8586c1e3d019947bfad78.svg";